import {
  array,
  bool,
  func, node,
  object,
  string,
} from 'prop-types';
import { createContext, useContext, useState } from 'react';

import localeConfigs from 'utils/localeConfigs';

export const i18nContext = createContext(undefined);

const I18nProvider = ({
  t, locale, countries, children, profileData, detectedCountry, appmode, popupInfo, additionalAttributes,
  userInteracted,
}) => {
  const [ bagLength, setBagLength ] = useState(0);
  const [ bag, setBag ] = useState(null);
  const [ bagHasMembersOnlyProduct, setBagHasMemberOnlyProduct ] = useState(false);
  const [ promoLabel, setPromoLabel ] = useState(null);
  const [ promoLabelType, setPromoLabelType ] = useState('progress');
  const [ searchQuery, setSearchQuery ] = useState('');
  const [ searchQueryShadow, setSearchQueryShadow ] = useState('');
  // utilizo un queryShadow porque el searchQuery acciona un useEffect en la pagina de /search, asi que tengo que poder distinguirlo para el input en mobile que se puede accionar con el boton de la lupa.
  const [ recommendedProductsForBag, setRecommendedProductsForBag ] = useState([]);

  const wrappedLocaleConfigs = {};

  Object.keys(localeConfigs).forEach((localeConfKey) => {
    wrappedLocaleConfigs[localeConfKey] = localeConfigs[localeConfKey](t);
  });

  return (
  <i18nContext.Provider value={{
    t,
    locale,
    countries,
    localeConfigs: wrappedLocaleConfigs,
    profileData,
    bagLength,
    setBagLength,
    bag,
    setBag,
    bagHasMembersOnlyProduct,
    setBagHasMemberOnlyProduct,
    promoLabel,
    setPromoLabel,
    promoLabelType,
    setPromoLabelType,
    searchQuery,
    setSearchQuery,
    searchQueryShadow,
    setSearchQueryShadow,
    detectedCountry,
    appmode,
    popupInfo,
    additionalAttributes,
    recommendedProductsForBag,
    setRecommendedProductsForBag,
    userInteracted,
  }}>
    { children }
  </i18nContext.Provider>
  );
};

export function useI18n() {
  const context = useContext(i18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within a I18nProvider');
  }
  return context;
}

I18nProvider.propTypes = {
  children: node,
  locale: string,
  countries: array,
  t: func,
  profileData: object,
  detectedCountry: string,
  appmode: bool,
  popupInfo: object,
  additionalAttributes: object,
  userInteracted: bool,
};

export default I18nProvider;
